import type { LogcatLineView, SequenceRule, SequenceStep } from '../types';
import { matchKeywordsAgainstLine, type KeywordMatch } from './keyword';

/**
 * Step-level 命中（不查看 forbidden / 时间窗）。语义与 KeywordRule 对齐：
 * tag/level 白名单 + 三段式调度。
 */
export function matchStep(step: SequenceStep, line: LogcatLineView): KeywordMatch {
  if (step.tags && step.tags.length > 0 && !step.tags.includes(line.tag)) {
    return { hit: false };
  }
  if (step.levels && step.levels.length > 0) {
    const lv = line.level;
    if (lv === '?' || !step.levels.includes(lv)) return { hit: false };
  }
  if (!step.keywords || step.keywords.length === 0) return { hit: false };
  return matchKeywordsAgainstLine(
    step.keywords,
    { ignoreCase: step.ignoreCase, strict: step.strict },
    line,
    step,
  );
}

/**
 * Forbidden 检查：当前 step 仍未命中时，遇到 forbidden 关键字立刻 fail。
 * 仅按字面 substring 比对，不参与 fuzzy（避免 forbidden 误命中）。
 */
export function hitsForbidden(step: SequenceStep, line: LogcatLineView): boolean {
  if (!step.forbiddenKeywords || step.forbiddenKeywords.length === 0) return false;
  const ignoreCase = !!step.ignoreCase;
  const target = ignoreCase ? line.msg.toLowerCase() : line.msg;
  const targetRaw = ignoreCase ? line.raw.toLowerCase() : line.raw;
  for (const kRaw of step.forbiddenKeywords) {
    const k = ignoreCase ? kRaw.toLowerCase() : kRaw;
    if (k.length === 0) continue;
    if (target.includes(k)) return true;
    if (target !== targetRaw && targetRaw.includes(k)) return true;
  }
  return false;
}

/** 用于 SuiteRunner 在状态机中查询当前步骤的元信息。 */
export function describeStep(rule: SequenceRule, idx: number): string {
  const s = rule.steps[idx];
  if (!s) return `step[${idx}]`;
  if (s.name) return s.name;
  if (s.keywords && s.keywords.length > 0) return `keyword:${s.keywords[0]}`;
  return `step[${idx}]`;
}
